import {
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    NIGHTLIFE_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import { ArrowRightChunky, DiscoBall } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import { STATSIG_EVENT_NAMES } from '../../experimentation';
import './NightlifePromoBanner.scss';

export const NightlifePromoBanner = () => {
    const titleFirstLine = gettext('Live your best nightlife.');
    const titleSecondLine = gettext('Discover more events.');
    const ctaLink = `/b/local/${EVENTBRITE_CATEGORY_TO_REFINEMENT[NIGHTLIFE_EVENTBRITE_CATEGORY]}/?utm_source=listing_nightlife_banner_click`;

    const _handleCtaOnClick = () => {
        logEvent(STATSIG_EVENT_NAMES.LISTING_NIGHTLIFE_BANNER_CLICK);
    };

    return (
        <section
            className="nightlife_promo_banner"
            data-testid={'nightlife-promo'}
        >
            <a
                href={ctaLink}
                onClick={_handleCtaOnClick}
                data-heap-id="nightlife_banner__cta"
                data-show-nightlife-promo-banner
            >
                <div className="nightlife-promo-banner-wrapper">
                    <div className="nightlife-promo-banner__image">
                        <DiscoBall />
                    </div>
                    <div className="nightlife_promo_banner__text">
                        <span className="text_title">{titleFirstLine} </span>
                        <span className="text_subtitle">{titleSecondLine}</span>
                    </div>
                    <div className="nightlife-promo-banner__arrow">
                        <ArrowRightChunky />
                    </div>
                </div>
            </a>
        </section>
    );
};
